import { RefreshCw } from 'lucide-react';
import { BrandStatusPage } from './BrandStatusPage';
import { ProductLogo } from '@/shared/ui/brand';

export interface ChunkErrorPageProps {
  layout?: 'viewport' | 'embedded';
}

/**
 * Shown when a lazy chunk fails to load (stale deploy / network).
 */
export function ChunkErrorPage({ layout = 'embedded' }: ChunkErrorPageProps): JSX.Element {
  return (
    <BrandStatusPage
      layout={layout}
      tone="brand"
      heroSize="md"
      heroMotion="float"
      showSparkles
      showLogo={layout === 'viewport'}
      hero={<ProductLogo className="size-12" />}
      statusPill={
        <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-brand-700">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-500" />
          Update available
        </div>
      }
      title="A newer version is ready."
      description="This screen couldn't load because the app was updated. Reload to get the latest DentXE build."
      primaryAction={{
        label: 'Reload app',
        onClick: () => window.location.reload(),
        icon: RefreshCw,
        variant: 'primary',
      }}
      footer="Chunk load · DentXE"
    />
  );
}
